import { useCallback, useState } from "react";

interface ErrorDisplayProps {
  error: Error | string;
  message?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, message }) => {
  const [isVisible, setIsVisible] = useState(true);

  const errorMessageString = typeof error === "string" ? error : error.message;
  const errorMessage =
    message || errorMessageString || "An unknown error occurred";

  const handleDismiss = useCallback(() => {
    setIsVisible(false);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="error-display alert alert-danger" onClick={handleDismiss}>
      {errorMessage}
    </div>
  );
};

export default ErrorDisplay;
